import {
  ApiGetRequest,
  ApiPostMultipart,
  ApiPostRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'List Signature',
    title_bank: 'Akun Jenis Pembayaran',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'Signature',
        href: '/adm/conf/signature',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_user_signature',
    sortDesc: true,
    fields: [
      {
        key: 'karyawan',
        label: 'Karyawan',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '80px',
        },
      },
    ],
    detail: false,
    form: {
      id_account: '',
      acc_code: '',
      acc_name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeSignature(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchSignature(context, params = null) {
    let result = await ApiGetRequest(`conf/user-signature`, params);
    return !result.error ? result.data.object : [];
  },

  async getListSignature({ commit, state }) {
    commit('changeSignature', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/user-signature`, params);
    commit('changeSignature', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailSignature({ commit, state }, payload = null) {
    commit('changeSignature', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`conf/user-signature/${payload.id}`);
    commit('changeSignature', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async uploadImageSignature({ commit, state }, payload) {
    commit('changeSignature', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeSignature', {
      loading: false,
    });

    if (!result.error) {
      commit('changeSignature', {
        form: {
          ...data.form,
          signature: result.data.object,
        },
      });
    }
  },

  async createSignature({ commit, state, dispatch }) {
    commit('changeSignature', {
      loading: true,
    });

    let result = await ApiPostRequest(`conf/user-signature`, state.data.form);

    commit('changeSignature', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSignature({ commit, state, dispatch }, payload = null) {
    commit('changeSignature', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `conf/user-signature/${payload.id}`,
      state.data.form
    );

    commit('changeSignature', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },
};
